import {
  IUpdateFlashdealTimespanRequest,
  IUpdateProductsBySectionRequest,
} from '../../types/api/request/customerapprequest';
import {
  IGetAllProductBySectionResponse,
  IToggleEnableFlashdealResponse,
  IUpdateFlashdealTimespanResponse,
  IUpdateProductsBySectionResponse,
} from '../../types/api/response/customerappresponse';
import axiosClient from '../axiosClient';
import { CustomerAppEndpoints } from '../endpoints/customerApp';

export const CustomerAppService = {
  async getAllProductsBySection(section: string): Promise<IGetAllProductBySectionResponse> {
    const url = CustomerAppEndpoints.GET_PRODUCTS_BY_SECTION.replace(':section', section);
    const res = await axiosClient.get<IGetAllProductBySectionResponse>(url);

    return res.data;
  },
  async updateProductsBySection(
    section: string,
    payload: IUpdateProductsBySectionRequest,
  ): Promise<IUpdateProductsBySectionResponse> {
    const url = CustomerAppEndpoints.UPDATE_PRODUCTS.replace(':section', section);
    const res = await axiosClient.post<IUpdateProductsBySectionResponse>(url, payload);

    return res.data;
  },

  async toggleEnableFlashdeal(): Promise<IToggleEnableFlashdealResponse> {
    const res = await axiosClient.post<IToggleEnableFlashdealResponse>(
      CustomerAppEndpoints.TOGGLE_ENABLE_FLASHDEAL,
    );
    return res.data;
  },

  async updateFlashdealSchedule(
    payload: IUpdateFlashdealTimespanRequest,
  ): Promise<IUpdateFlashdealTimespanResponse> {
    const res = await axiosClient.post<IUpdateFlashdealTimespanResponse>(
      CustomerAppEndpoints.UPDATE_FLASHDEAL_TIMESPAN,
      payload,
    );

    return res.data;
  },
};
